import ApplicationController from 'javascript/controllers/application_controller';

export default class AsyncComponentUpdateController extends ApplicationController {
  async updateComponent({ componentUrl, componentSelector, body } = {}) {
    const res = await fetch(componentUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getMetaValue('csrf-token'),
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) throw new Error(res.statusText);

    const data = await res.json();
    const component =
      this.element.ownerDocument.querySelector(componentSelector);

    component.outerHTML = data.html;

    return data;
  }

  async triggerUpdateFromCustomEvent(event) {
    await this.updateComponent(event.detail);
  }

  getMetaValue(name) {
    const element = document.head.querySelector(`meta[name="${name}"]`);
    return element && element.content;
  }

  isMobile() {
    return window.innerWidth <= 719;
  }
}
